import {
    CONFIRMED_CREATE_MODULE_ACTION,
    CONFIRMED_DELETE_MODULE_ACTION,
    CONFIRMED_EDIT_MODULE_ACTION,
    CONFIRMED_GET_MODULES,
    CREATE_MODULE_ACTION,    
    CREATE_MODULE_ERROR_ACTION,
    CLEAR_MODULE_ERROR,
    LOADING_MODULES,
    LOADING_TOGGLE_ACTION
} from '../actions/ModuleTypes';

const initialState = {
    modules: [],
    loading: false,
    createModuleError: {}
};

export default function ModuleReducer(state = initialState, actions) {
    if (actions.type === CREATE_MODULE_ACTION) { 
        return {
            ...state,
            modules: [...state.modules],
        };
    }

    if (actions.type === CONFIRMED_DELETE_MODULE_ACTION) {
        const modules = state.modules.filter(module => module.id !== actions.payload);
        return {
            ...state,
            modules,
        };
    }

    if (actions.type === CONFIRMED_EDIT_MODULE_ACTION) {
        const modules = state.modules.map(module => 
            module.id === actions.payload.id ? actions.payload : module
        );
        return {
            ...state,
            modules,
        };
    }

    if (actions.type === CONFIRMED_CREATE_MODULE_ACTION) {
        return {
            ...state,
            modules: [...state.modules, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_MODULES) {
        return {
            ...state,
            modules: actions.payload,
        };
    }

    if (actions.type === LOADING_MODULES) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_MODULE_ERROR_ACTION) {
        return {
            ...state,
            createModuleError: actions.payload,
        };
    }

    if (actions.type === CLEAR_MODULE_ERROR) {
        return {
            ...state,
            createModuleError: {},
        };
    }
    if (actions.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            loading: actions.payload,
        };
    }
    return state;
}
